import React from 'react';
import PropTypes from 'prop-types';
import {Modal, Button, Image} from '@nl/component';
import {Link} from '@nl/core';
import {shallowEqual, useSelector} from 'react-redux';
import {useI18n} from '@nl/i18n';

import previewImg from '../../assets/images/freesample/confirmation_lpppreview.png';

function FreeSampleModal(props) {
	const {minutes, show, onHide} = props;
	const [title, subtitle_domestic, subtitle_international, getMinutes] = useI18n(['title', 'subtitle_domestic', 'subtitle_international', 'get_minutes_button'], {
		keyPrefix: 'freesample_popup_',
	});
	const subButton = useI18n('freesample_notice_subscribe_button');
	const {LOC_SERVER, WATCH_SITE_PREFIX, isDomestic} = useSelector((state) => ({
		WATCH_SITE_PREFIX: state.config.data.WATCH_SITE_PREFIX,
		isDomestic: state.config.data.isDomestic,
		LOC_SERVER: state.config.data.LOC_SERVER,
	}), shallowEqual);

	return (
			<>
				<Modal show={show}
							 onHide={onHide}
							 size="lg"
							 aria-labelledby="preview end modal"
							 centered
							 dialogClassName="preview--modal"
				>
					<Modal.Header closeButton>
						<Modal.Title id="contained-modal-title-vcenter">
							{title.replace('{0}', minutes)}
						</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						<div className="subtitle">
							<span>{isDomestic ? subtitle_domestic : subtitle_international}</span>
						</div>
						<div className="preview-img">
							<Image src={previewImg} alt="confirmation lpppreview" />
						</div>
					</Modal.Body>
					<Modal.Footer>
						<Link to={`${WATCH_SITE_PREFIX}streaming-subscriptions`}>
							<Button className="subscribe-btn">{subButton}</Button>
						</Link>
						<Link to={`${LOC_SERVER}secure/subscription?sku=BLPP${isDomestic ? 'US' : ''}PREVIEW`}>
							<Button className="cancel-btn">{getMinutes.replace('{0}', minutes)}</Button>
						</Link>
					</Modal.Footer>
				</Modal>
			</>
	);
}

FreeSampleModal.defaultProps = {
	onHide: null,
	minutes: 0,
};

FreeSampleModal.propTypes = {
	show: PropTypes.bool.isRequired,
	onHide: PropTypes.func,
	minutes: PropTypes.number,
};

export default FreeSampleModal;
